<div class="faq-categories">
  <p class="muted">
    Categories group the questions on a FAQ block set to <strong>Group by category</strong>.
    The order here is the order they appear on the page.
  </p>

  <p *ngIf="loading" class="muted">Loading…</p>

  <div *ngIf="!loading">
    <div *ngFor="let row of rows; let i = index; let last = last" class="cat-row">
      <div class="cat-move">
        <button pButton pRipple type="button" icon="pi pi-chevron-up"
          class="p-button-rounded p-button-text p-button-sm"
          [disabled]="i === 0" (click)="move(i, -1)" title="Move up"></button>
        <button pButton pRipple type="button" icon="pi pi-chevron-down"
          class="p-button-rounded p-button-text p-button-sm"
          [disabled]="last" (click)="move(i, 1)" title="Move down"></button>
      </div>

      <div class="cat-fields">
        <input pInputText type="text" class="p-inputtext cat-name"
          [(ngModel)]="row.name" placeholder="Costs and payment" />
        <textarea pInputTextarea rows="2" class="p-inputtext cat-desc"
          [(ngModel)]="row.description"
          placeholder="Optional intro paragraph under this heading."></textarea>
      </div>

      <button pButton pRipple type="button" icon="pi pi-times"
        class="p-button-text p-button-danger" (click)="removeRow(i)"
        title="Remove category"></button>
    </div>

    <button pButton pRipple type="button" label="Add category" icon="pi pi-plus"
      class="p-button-text p-button-sm" (click)="addRow()"></button>
  </div>

  <div class="actions">
    <button pButton pRipple type="button" label="Cancel" class="p-button-text"
      [disabled]="saving" (click)="cancel()"></button>
    <button pButton pRipple type="button" label="Save" icon="pi pi-check"
      [disabled]="saving || loading" [loading]="saving" (click)="save()"></button>
  </div>
</div>
